<template>
  <div class="operation_log">
    <p>操作日志</p>
		<log type="1"></log>
  </div>
</template>

<script>
	import Log from '@/components/UserSettings/Log'
  export default {
    name: 'OperationLog',
		components: {
			Log
		}
  }
</script>

<style>
.operation_log > p{
  font-size:24px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:24px;
  margin-bottom: 24px;
}
</style>